import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import dayjs, { Dayjs } from "dayjs";
import { TimePicker } from "antd";
export default function LocalTimePicker({ value = null, onChange = undefined, allowClear = true, format = "HH:mm", placeholder = "Time", disabled = false }) {
    function emitOnChange(dayjs) {
        if (dayjs && onChange) {
            onChange(dayjs.format(format));
        }
        else if (onChange) {
            onChange(null);
        }
    }
    return (_jsx(TimePicker, { value: value ? dayjs(value, format) : null, onChange: emitOnChange, allowClear: allowClear, format: format, placeholder: placeholder, disabled: disabled }));
}
